// extracted by mini-css-extract-plugin
module.exports = {"root":"iBPvBwcJ","toggleWrapper":"h1RQzwjQ"};